import React from 'react';

const UniplacesSVG = props => (
  <svg width={12} height={15} viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.675.482.965 0C.368 0-.07.442.008 1.046l2.47 18.334c.081.602.558.803 1.038.442l1.991-1.407A3.157 3.157 0 0 1 7.5 17.85c.757.04 6.814.442 6.814.442.291.009.575-.093.796-.285.221-.191.364-.46.399-.752l1.154-15.637a1.033 1.033 0 0 0-.58-1.04 1.01 1.01 0 0 0-.407-.096Zm-.327 1.729-.92 14.505a.398.398 0 0 1-.31.36.39.39 0 0 1-.167 0l-4.658-.994c-.679-.123-1.117-.523-1.196-1.167L6.947 4.021a.487.487 0 0 1 .399-.523l7.61-1.618c.233-.072.392.097.392.33Z"
      fill="#647A85"
    />
  </svg>
);

export default UniplacesSVG;
